export const referrals = {
  menu: {
    label: "ادعُ واربح",
    badge: "اربح",
  },
  welcomeCard: {
    title: "قد تصبح خطتك مجانية",
    desc: "ادعُ مضيفين آخرين واربح جزءًا من كل ما يدفعونه، إلى الأبد.",
  },
  page: {
    loading: "جارٍ تحميل دعواتك…",
    previewNotice: "معاينة ببيانات تجريبية. ستظهر دعواتك الحقيقية هنا عند تفعيل البرنامج.",
  },
  hero: {
    title: "ادعُ مضيفين آخرين واستخدم WACheckin مجانًا",
    subtitle: "مقابل كل مضيف يشترك عبر رابطك، تربح {percent}% من كل ما يدفعه، كل شهر وإلى الأبد. ويبدأ زميلك بخصم {friendPercent}%.",
    personal: "تكلفة خطتك {price} شهريًا. مع {count} مدعوين مثلك، لن تدفع شيئًا بعد الآن.",
    personalGeneric: "مع {count} مضيفين مثلك يدفعون، تصبح خطتك مجانية.",
  },
  rewards: {
    youGet: "تحصل على",
    youGetBig: "{percent}% من كل دفعة",
    youGetSmall: "من كل مضيف تدعوه، كل شهر وإلى الأبد",
    friendGets: "يحصل زميلك على",
    friendGetsBig: "خصم {percent}%",
    friendGetsSmall: "خلال أول {months} أشهر",
    example: "إذا دعوت مضيفًا لديه {units} شقق، تربح نحو {amount} سنويًا ما دام معنا.",
  },
  welcomeOffer: {
    title: "هديتك الترحيبية",
    text: "دعاك {name} إلى WACheckin: لديك خصم {percent}% خلال أول {months} أشهر. يُطبَّق عند اشتراكك في خطتك.",
  },
  share: {
    title: "رابط الدعوة الخاص بك",
    codeLabel: "رمزك",
    copy: "نسخ الرابط",
    copied: "تم النسخ",
    whatsapp: "واتساب",
    invite: "إرسال عبر البريد",
    more: "المزيد",
    message: "أنصحك بـ WACheckin: أستخدمه لتسجيل الوصول عبر الإنترنت ورسائل الضيوف وربط Booking وAirbnb، ويوفر لي الكثير من الوقت. مع رابطي تحصل على خصم {percent}% خلال أول {months} أشهر: {link}",
    emailSubject: "خصم {percent}% على WACheckin عبر رابطي",
  },
  invite: {
    title: "ادعُ عبر البريد الإلكتروني",
    subtitle: "سنرسل إلى زميلك دعوة شخصية تتضمن رابطك وخصمه البالغ {percent}%.",
    emailLabel: "البريد الإلكتروني لزميلك",
    emailPlaceholder: "name@company.com",
    languageLabel: "لغة البريد",
    cancel: "إلغاء",
    send: "إرسال الدعوة",
    sending: "جارٍ الإرسال…",
    successTitle: "تم إرسال الدعوة!",
    successDesc: "أرسلنا دعوتك إلى {email}.",
    another: "دعوة زميل آخر",
    close: "إغلاق",
    errors: {
      invalidEmail: "أدخل بريدًا إلكترونيًا صالحًا.",
      selfInvite: "لا يمكنك إرسال الدعوة إلى بريدك الإلكتروني.",
      alreadyInvited: "لقد دعوت هذا البريد مؤخرًا. يمكنك المحاولة مجددًا بعد بضعة أيام.",
      dailyLimit: "لقد بلغت الحد الأقصى للدعوات اليوم. حاول مجددًا غدًا.",
      tooFast: "محاولات كثيرة متتالية. انتظر دقيقة ثم حاول مجددًا.",
      generic: "تعذّر إرسال الدعوة. حاول مجددًا.",
    },
  },
  message: {
    title: "رسالة جاهزة للمشاركة",
    hint: "الصقها في مجموعات المضيفين أو المنتديات أو وسائل التواصل. تنجح أكثر إذا أضفت جملة من عندك.",
    copy: "نسخ الرسالة",
  },
  how: {
    title: "كيف يعمل",
    stepLabel: "الخطوة {n}",
    step1Title: "شارك رابطك",
    step1Desc: "عبر واتساب أو البريد الإلكتروني أو في مجموعات المضيفين.",
    step2Title: "يشترك زميلك بخصم",
    step2Desc: "يسجّل عبر رابطك ويبدأ بخصم {percent}%.",
    step3Title: "تربح كل شهر",
    step3Desc: "يتحول {percent}% من كل دفعة إلى رصيد لك، إلى الأبد. تُحتسب الدفعة الأولى بعد {days} يومًا.",
  },
  results: {
    title: "نتائجك",
    celebrate: "ربحت {amount} حتى الآن.",
    coverage: "يغطي مدعووك الآن {percent}% من خطتك",
    coverageFree: "خطتك أصبحت مجانية",
    coverageHint: "تكلفة خطتك {price} شهريًا ويمنحك مدعووك {earning} شهريًا.",
  },
  stats: {
    invited: "المدعوون",
    subscribed: "المشتركون",
    monthlyEarning: "أرباحك الشهرية",
    creditAvailable: "الرصيد المتاح",
    creditEarned: "{amount} مكتسبة إجمالًا",
    creditHint: "يُخصم تلقائيًا من فاتورتك القادمة",
  },
  list: {
    title: "دعواتك",
    colName: "الحساب",
    colDate: "تاريخ التسجيل",
    colStatus: "الحالة",
    colReward: "ما تربحه",
    empty: "لم تدعُ أحدًا بعد. أول مضيف يشترك عبر رابطك يبدأ في منحك رصيدًا كل شهر.",
  },
  status: {
    registered: "مسجّل",
    subscribed: "مشترك",
    rewarded: "نشط",
    canceled: "ألغى الاشتراك",
    rejected: "غير مؤهل",
  },
  reward: {
    waiting: "بانتظار دفعته الأولى",
    startsOn: "تبدأ الربح في {date}",
    earning: "{monthly} شهريًا، {earned} إجمالًا",
    earningNoPlan: "{earned} إجمالًا",
    canceled: "{earned} مكتسبة",
  },
  reasons: {
    duplicate: "حساب مكرر",
    selfReferral: "دعوة ذاتية",
  },
  faq: {
    title: "الأسئلة الشائعة",
    howMuchQ: "كم أربح؟",
    howMuchA: "{percent}% من كل ما يدفعه كل مضيف تدعوه (دون الضرائب)، كل شهر وإلى الأبد، دون حد لعدد المدعوين. إذا دفع {price} شهريًا، تربح نحو {amount} كل شهر.",
    whenQ: "متى أحصل عليه؟",
    whenA: "في كل مرة يدفع فيها مدعوك، يُضاف المبلغ تلقائيًا إلى رصيدك. تُحتسب دفعته الأولى بعد {days} يومًا، تحسبًا لإلغائه الاشتراك مباشرة بعد الاشتراك.",
    whereQ: "أين يُستخدم الرصيد؟",
    whereA: "يُخصم تلقائيًا من فواتير WACheckin القادمة. وإذا لم تشترك بعد، يُطبَّق على فاتورتك الأولى.",
    limitQ: "هل يوجد حد؟",
    limitA: "لا يوجد حد لعدد المدعوين ولا للمدة. الحد الوحيد: الرصيد المتراكم غير المستخدم يصل كحد أقصى إلى {months} شهرًا من خطتك. ما دمت عند هذا الحد تبقى خطتك مجانية، وما يزيد عليه لا يتراكم.",
    stopQ: "متى أتوقف عن الربح؟",
    stopA: "إذا ألغى مدعوك اشتراكه تتوقف عن الربح منه، وإذا ألغيت أنت اشتراكك تتوقف عن تجميع الرصيد.",
    whoQ: "من يمكنني دعوته؟",
    whoA: "أي مضيف أو فندق لا يستخدم WACheckin بعد. لا تُقبل الدعوات الذاتية ولا الحسابات المكررة.",
  },
};
